import { Box } from "@mui/material";
import HeroSection from "../../components/about-us/HeroSection";
import ValuesSection from "../../components/about-us/ValuesSection";
import TeamSection from "../../components/about-us/TeamSection/TeamGrid";
import StatsSection from "../../components/about-us/StatsSection";
import ContactSection from "../../components/about-us/ContactSection";

const AboutUsPage = () => {
  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#fff", minHeight: "100vh" }}>
      <HeroSection />
      <ValuesSection />
      <TeamSection />
      <StatsSection />
      <ContactSection />
    </Box>
  );
};

export default AboutUsPage;